import React, { useState } from "react";
import {
  makeStyles,
  Box,
  Divider,
  Checkbox,
  IconButton,
  Typography,
  InputBase
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import SearchIcon from "@material-ui/icons/Search";
// import DeleteIcon from "@material-ui/icons/Delete";
import LightTooltip from "./LightTooltip";
import OptimizedTooltip from "./OptimizedTooltip";

const useStyles = makeStyles(theme => ({
  selectAllBtn: {
    "& svg": {
      color: "inherit"
    }
  }
}));

function SearchBox({
  data,
  label,
  value,
  selected,
  unscheduled,
  handleChange,
  filteredData,
  handleSelectAllClick,
  handleMultipleDownload
  //   handleMultipleDelete,
}) {
  const classes = useStyles();
  const [focused, setFocused] = useState("");

  const pluralLabel = label + "s";

  return (
    <Box
      display="flex"
      style={{ backgroundColor: "#eee" }}
      borderRadius={6}
      position="relative"
      height={48}
      flexShrink={0}
    >
      {!data.length && (
        <LightTooltip
          text={`Add a ${label} to be able to search`}
          fromRight={true}
        />
      )}
      <Box display="flex" alignItems="center" pl={0.5} pr={0.5}>
        <Checkbox
          color="primary"
          indeterminate={
            selected?.length > 0 && selected?.length < filteredData.length
          }
          onChange={handleSelectAllClick}
          checked={
            data.length > 0 &&
            filteredData.length &&
            selected?.length === filteredData.length
          }
          className={classes.selectAllBtn}
        />
      </Box>
      <Divider
        orientation="vertical"
        style={{
          height: "24px",
          alignSelf: "center",
          background: "#ddd",
          marginRight: "14px"
        }}
      />
      <Box
        flexGrow="1"
        display="flex"
        pr={2}
        alignItems="center"
        style={{ pointerEvents: data.length ? "all" : "none" }}
      >
        {selected?.length ? (
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            alignItems="center"
            ml={-1}
          >
            <div>
              {/* <IconButton
                onClick={() => {
                  handleMultipleDelete(selected);
                }}
              >
                <DeleteIcon />
              </IconButton> */}
              <IconButton
                onClick={() => {
                  handleMultipleDownload(selected);
                }}
              >
                <GetAppIcon />
              </IconButton>
            </div>
            <Typography color="textSecondary">
              Selected {unscheduled ? "" : pluralLabel}: {selected?.length}
            </Typography>
          </Box>
        ) : (
          <InputBase
            placeholder={`Search ${unscheduled ? "" : pluralLabel}`}
            inputProps={{
              "aria-label": `search ${pluralLabel}`,
              "data-cy": `${label}-searchInput`
            }}
            value={value || ""}
            onChange={handleChange}
            style={{ width: "100%" }}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
          />
        )}
      </Box>
      {!selected?.length && (
        <OptimizedTooltip placement="bottom" title="Search">
          <Box display="flex" alignItems="center" pl={1.75} pr={3.25}>
            <SearchIcon color={focused ? "primary" : "action"} />
          </Box>
        </OptimizedTooltip>
      )}
    </Box>
  );
}

export default SearchBox;
